import axios from '@/axios/'

const actions = {
  // Jチケット受取情報取得
  getReceiveinfo(_, param) {
    return axios.post('/GetTktReceiveinfo/1.0/', param)
  },
  // Jチケット譲渡・分配受取登録
  SetTktDistributeReceive(_, param){
    return axios.post('/SetTktDistributeReceive/1.0/', param)
  }
}

const state = {
  ticketEnckey: undefined
}

const mutations = {
  setTicketEnckey(state, ticketEnckey){
    state.ticketEnckey = ticketEnckey
  },
  
  clearTicketEnckey(state){
    state.ticketEnckey = undefined
  }
}

export default {
  namespaced: true,
  actions,
  state,
  mutations
}
